export default __webpack_public_path__ + "static/media/17-2.7131a5d4.mp3";